"use client";

import { useEffect, useState } from "react";
import styles from "./siteError.module.css";

export default function SiteError({ reset }: { error: Error & { digest?: string }; reset: () => void }) {
  const [english, setEnglish] = useState(false);
  useEffect(() => {
    const language = new URLSearchParams(window.location.search).get("lang") || document.documentElement.lang;
    setEnglish(language.toLowerCase().startsWith("en"));
  }, []);

  return <main className={styles.page}>
    <header className={styles.header}>INSPARKLE</header>
    <div className={styles.content}>
      <section className={styles.panel} role="alert">
        <h1>{english ? "This page is temporarily unavailable" : "页面暂时无法加载"}</h1>
        <p>{english ? "No operation was submitted. Please reload this page, or return home and try again later." : "本页没有提交任何操作。请重新加载，或返回首页稍后再试。"}</p>
        <div className={styles.actions}>
          <button type="button" onClick={reset}>{english ? "Reload" : "重新加载"}</button>
          <a href={english ? "/?lang=en-US" : "/?lang=zh-CN"}>{english ? "Back to home" : "返回首页"}</a>
        </div>
      </section>
    </div>
  </main>;
}
